/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSubsetTransform } from '../../factoriesAny.js';
export var subsetTransformDependencies = {
  matrixDependencies,
  typedDependencies,
  createSubsetTransform
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesSubsetTransform.generated.js
// module id = null
// module chunks = 